import {
  faTimesCircle,
  faCaretUp,
  faCaretDown,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  changeFormulaType,
  changeFormulaTypeFromDays,
  changeFormulaTypeFromGranularToRaw,
} from "../../actions/formulaAction";
import { getFixedDosage } from "../../utils/helper";

const DaysPopup = ({
  closePopup,
  multiplier,
  setMultiplier,
  getDosageToChange,
  totalDosage,
  setTotalDosage,
  totalDosageRef,
  rawGramPerDayBeforeConversion,
}) => {
  const dispatch = useDispatch();
  const [innerDays, setInnerDays] = useState(1);

  const performConversion = (value) => {
    dispatch(changeFormulaTypeFromGranularToRaw(true, 1));
    dispatch(
      changeFormulaType(true, getDosageToChange(parseFloat(value)), null, true)
    );
    dispatch(changeFormulaTypeFromDays(false, 1));
  };
  const performConversionForDays = (multiplier) => {
    dispatch(changeFormulaTypeFromGranularToRaw(true, 1));
    dispatch(
      changeFormulaType(
        true,
        getDosageToChange(
          getFixedDosage(rawGramPerDayBeforeConversion) * multiplier
        ),
        null,
        true
      )
    );
    dispatch(changeFormulaTypeFromDays(false, 1));
  };
  return (
    <Modal show={true} id="prescription-popup">
      <Modal.Body style={{ width: "605px" }}>
        <>
          <div className="prescription-detail">
            <div className="close-btn">
              <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
            </div>
            <div className="inner-section">
              <div className="row">
                <div className="col-md-12">
                  <p className="heading">
                    Adjust the total effortlessly by adjusting the number of
                    days or directly inputting your desired amount in the Total
                    Grams field.
                  </p>
                  {rawGramPerDayBeforeConversion != null ? (
                    <p
                      className="page-desc mb-4"
                      style={{
                        marginBottom: 0,
                        color: "#e5e5e5",
                        opacity: 0.6,
                        fontWeight: 500,
                      }}
                    >
                      Note: Daily Recommended Dosage:{" "}
                      {getFixedDosage(rawGramPerDayBeforeConversion)}g
                      (equivalent to 1 packet of Raw herbs)
                    </p>
                  ) : (
                    ""
                  )}
                  <div className="d-flex align-items-center ">
                    <div className="d-flex align-items-center mr-5">
                      <p style={{ margin: 0, color: "white" }}> Days:</p>
                      <div className="number-field ml-3">
                        <input
                          type="number"
                          min="0"
                          value={multiplier}
                          onChange={(e) => {
                            if (parseInt(e.target.value) > 1) {
                              setMultiplier(parseInt(e.target.value));
                              performConversionForDays(
                                parseInt(e.target.value)
                              );
                            } else {
                              setMultiplier(1);
                              performConversionForDays(1);
                            }
                          }}
                        />
                        <div>
                          <div
                            className="icon"
                            onClick={() => {
                              setMultiplier(multiplier + 1);
                              performConversionForDays(
                                parseInt(multiplier) + 1
                              );
                            }}
                          >
                            <FontAwesomeIcon icon={faCaretUp} />
                          </div>
                          <div
                            className="icon"
                            onClick={() => {
                              if (multiplier > 1) {
                                setMultiplier(multiplier - 1);
                                performConversionForDays(
                                  parseInt(multiplier) - 1
                                );
                              } else {
                                setMultiplier(1);
                                performConversionForDays(1);
                              }
                            }}
                          >
                            <FontAwesomeIcon icon={faCaretDown} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center mr-5">
                      <p style={{ margin: 0, color: "white" }}> Total Grams:</p>
                      <div className={` number-field mr-2 ml-3`}>
                        <input
                          //  disabled={rawGramPerDayBeforeConversion != null}
                          type="number"
                          min="0"
                          step="any"
                          value={totalDosage}
                          onChange={(e) => setTotalDosage(e.target.value)}
                          onBlur={(e) => {
                            performConversion(e.target.value);
                            totalDosageRef.current.style.border =
                              "1px solid transparent";
                          }}
                        />
                      </div>
                      <p style={{ margin: 0, color: "white" }}> grams</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="submit-section d-flex justify-content-end">
            <button className="btn-orange" onClick={closePopup}>
              OK
            </button>
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
};
export default DaysPopup;
